export default {
	isAuthenticated: false,
	token: '',
	currUser : {},
};